import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
import { DarkButton } from 'components/style/Global';
import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { TiArrowUnsorted, TiFilter } from 'react-icons/ti';
import { useTemplateContext } from 'context/TemplateContext';
import { AiOutlineDelete } from 'react-icons/ai';
import { IoMdClose } from 'react-icons/io';
import { useCampaignContext } from 'context/CampaignContext';
import { useGetStoredQueriesDetails } from 'customHooks/useGetStoredQueriesDetails';
import { API } from 'aws-amplify';
import { deleteStoredQuery } from 'graphql/mutations';
import { PublishContext } from 'context/PublishContext';
import { DeleteStoredQueryMutation } from 'API';
import APIContext from 'context/APIContext';

const Modal = styled.div`
  position: fixed; /* Stay in place */
  z-index: 3; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  display: flex;
  justify-content: center;
  align-items: center;

  h3 {
    display: block;
    margin-bottom: 1vh;
    margin-top: 0.3vh;
    font-weight: normal;
    color: ${({ theme }) => theme.primaryGray};
    font-family: 'FontRegular', sans-serif;
    font-size: 14px;
  }

  h1 {
    text-align: center;
    font-size: 30px;
  }

  .tableContainer {
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    //  padding: 0.5vw 0.9vw;
    min-height: 200px;
    max-height: 520px;
    margin: 30px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    position: relative;

    thead {
      position: sticky;
      top: 0;
      z-index: 2;
      background: ${({ theme }) => theme.background};
    }

    tbody {
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.placeholderBackground};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.border};
      border-radius: 3px;
      transition: background 0.2s ease;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.primaryGray};
    }

    & {
      -ms-overflow-style: auto;
      scrollbar-width: thin;
    }

    tr th {
      text-align: left;
      border-bottom: 2px solid ${({ theme }) => theme.border};
      font-size: 14px;
      padding: 16px 12px;
      color: ${({ theme }) => theme.primaryGray};
      font-weight: 600;
      background: ${({ theme }) => theme.background};
      transition: all 0.2s ease;
      user-select: none;
    }

    th {
      position: sticky;
      top: 0;
    }

    tr td {
      font-size: 12px;
      padding: 16px 12px;
      border-bottom: 1px solid ${({ theme }) => theme.border}20;
      transition: all 0.3s ease;
    }

    tbody tr {
      color: ${({ theme }) => theme.secondaryGray};
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: ${({ theme }) => theme.placeholderBackground};
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
        color: ${({ theme }) => theme.primaryGray};

        td {
          /* color: ${({ theme }) => theme.primaryGray}; */
        }

        td:first-child {
          padding-left: 14px;
        }
      }

      &:last-child td {
        border-bottom: none;
      }
    }
  }

  .messageContainer {
    padding: 1vw;
  }

  .filterDropdown {
    height: fit-content;
    width: calc(100% + 2vw);
    border: 2px solid ${({ theme }) => theme.border};
    position: absolute;
    padding: 0.9vw 0.9vw;
    background: ${({ theme }) => theme.placeholderBackground};
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(4px);

    label {
      padding: 8px 0;
      transition: all 0.2s ease;
      border-radius: 4px;
      padding-left: 8px;
      margin-bottom: 4px;

      &:hover {
        background: ${({ theme }) => theme.border}30;
        color: ${({ theme }) => theme.primaryGray};
      }

      input[type='checkbox'] {
        transition: all 0.2s ease;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .sortIcon {
    margin-left: 8px;
    opacity: 0.7;
    transition: all 0.2s ease;

    &:hover {
      opacity: 1;
      color: ${({ theme }) => theme.brand};
      transform: scale(1.1);
    }
  }

  .filterIcon {
    margin-left: 8px;
    opacity: 0.7;
    transition: all 0.2s ease;

    &:hover {
      opacity: 1;
      color: ${({ theme }) => theme.brand};
      transform: scale(1.1);
    }
  }

  .deleteIcon {
    opacity: 0.6;
    transition: all 0.2s ease;

    &:hover {
      opacity: 1;
      color: #ff4757;
      transform: scale(1.2);
    }
  }
`;

type Props = {
  setPickTemplateDisplay(arg: any): any;
};

function PickTemplate(props: Props) {
  const { templatesList, fetchTemplateById, templateDelete, saveTemplateMessage, fetchedPlaceholders } =
    useTemplateContext();
  const { activeCampaign, activeSubCampaign, dashType } = useCampaignContext();
  const { getEnvironment } = useContext(APIContext);
  const { unpublishCampaign } = useContext(PublishContext);
  // const { templatesList, fetchTemplateById, templateDelete, saveTemplateMessage } = useTemplateContext()
  const [selectedTemplate, setSelectedTemplate] = useState<any>();
  const [showFilter, setShowFilter] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [ownerList, setOwnerList] = useState([...new Set(templatesList.map((el: any) => el.CreatedBy))]);
  const [displayList, setDisplayList] = useState<any>(templatesList);
  const [filterList, setFilterList] = useState<any>([]);
  const [nameOrder, setNameOrder] = useState(true);
  const [dateOrder, setDateOrder] = useState(true);
  const [storedQueries, , , , , , ,] = useGetStoredQueriesDetails(activeCampaign, undefined, fetchedPlaceholders);

  // Filter stored queries for positions 1, 2, 3
  const filteredStoredQueries =
    storedQueries?.filter((el) =>
      dashType === 'DIGITAL'
        ? el.position?.startsWith('1') || el.position?.startsWith('2') || el.position?.startsWith('3')
        : dashType === 'SEARCH'
          ? el.position?.startsWith('Search')
          : true,
    ) ?? [];

  console.log('DISPLAY LIST', displayList);
  useEffect(() => {
    setDisplayList(templatesList);
  }, [templatesList]);

  const handleFilter = (e: any) => {
    e.target.checked
      ? setFilterList((ps: any) => [...ps, e.target.value])
      : setFilterList((ps: any) => ps.filter((el: any) => el !== e.target.value));
  };

  useEffect(() => {
    if (filterList.length > 0) {
      setDisplayList(templatesList.filter((item: any) => filterList.includes(item.CreatedBy)));
    } else {
      setDisplayList(templatesList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterList]);

  const handleOK = async () => {
    if (!selectedTemplate) {
      props.setPickTemplateDisplay(false);
      return;
    }

    // Check if stored queries exist
    if (filteredStoredQueries && filteredStoredQueries.length > 0) {
      setShowConfirmModal(true);
      return;
    }

    // Apply selected template directly if no stored queries
    fetchTemplateById(selectedTemplate.Id);
    props.setPickTemplateDisplay(false);
  };

  const handleConfirmDelete = async () => {
    setShowConfirmModal(false);
    setIsDeleting(true);

    try {
      const validPositions = storedQueries
        ?.filter(
          (item: any) =>
            item.position &&
            (item.position.startsWith('1') || item.position.startsWith('2') || item.position.startsWith('3')),
        )
        .map((item: any) => item.position.charAt(0))
        .filter((value: string, index: number, array: string[]) => array.indexOf(value) === index);

      if (validPositions && validPositions.length > 0) {
        const deleteRecursively = async (positions: string[], index: number = 0): Promise<void> => {
          if (index >= positions.length) {
            unpublishCampaign();
            return;
          }

          const success = await handleRemoveQ(positions[index]);
          if (success) {
            console.log(`Deleted position ${positions[index]}`);
          }

          await deleteRecursively(positions, index + 1);
        };

        await deleteRecursively(validPositions);
      }
    } catch (error) {
      console.error('Error deleting stored queries:', error);
      setIsDeleting(false);
      return;
    }

    setIsDeleting(false);
    // Apply selected template after deletion
    fetchTemplateById(selectedTemplate.Id);
    props.setPickTemplateDisplay(false);
  };

  const handleRemoveQ = async (position: string) => {
    try {
      const deleteQueries = (await API.graphql({
        query: deleteStoredQuery,
        variables: {
          campaign_id: activeCampaign?.campaignId,
          Environment: getEnvironment,
          placeholder: position,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteStoredQueryMutation };
      if (deleteQueries.data.deleteStoredQuery?.StatusCode === 200) {
        console.log(`Successfully deleted queries for position: ${position}`);
        return true;
      }
      return false;
    } catch (e) {
      console.log(`PROBLEM DELETING QUERIES FOR POSITION ${position}`, e);
      return false;
    }
  };

  return (
    <>
      {showConfirmModal && (
        <Modal style={{ zIndex: 4 }} onClick={() => setShowConfirmModal(false)}>
          <HeadModul onClick={(e) => e.stopPropagation()}>
            <ModulContainer onClick={(e) => e.stopPropagation()}>
              <h1>Confirm Action</h1>
              <div className="tableContainer messageContainer">
                <h3>
                  Applying this template will delete the stored queries.
                  <br />
                  Do you want to continue?
                </h3>

                <div style={{ display: 'flex', gap: '10px', alignSelf: 'flex-end' }}>
                  <button onClick={() => setShowConfirmModal(false)} className="scaleHover" type="button">
                    Cancel
                  </button>
                  <DarkButton onClick={handleConfirmDelete} disabled={isDeleting} className="scaleHover" type="button">
                    {isDeleting ? 'Deleting...' : 'Delete & Continue'}
                  </DarkButton>
                </div>
              </div>
            </ModulContainer>
          </HeadModul>
        </Modal>
      )}

      <Modal onClick={() => props.setPickTemplateDisplay(false)}>
        <HeadModul onClick={(e) => e.stopPropagation()}>
          <button type="button" className="x" onClick={() => props.setPickTemplateDisplay(false)}>
            {' '}
            <IoMdClose className="closeIcon" />
          </button>
          <ModulContainer onClick={(e) => e.stopPropagation()}>
            <h1>Select template</h1>
            <div className="tableContainer">
              <table>
                <thead style={{ zIndex: '1' }}>
                  <tr style={{ zIndex: '1' }}>
                    <th style={{ zIndex: '1' }}>
                      Name{' '}
                      <TiArrowUnsorted
                        className="sortIcon"
                        onClick={() => {
                          const newArr = displayList.sort((a: any, b: any) =>
                            nameOrder ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name),
                          );
                          setDisplayList(newArr);
                          setNameOrder(!nameOrder);
                        }}
                      />
                    </th>

                    <th style={{ zIndex: '1' }}>
                      Owner <TiFilter className="filterIcon" onClick={() => setShowFilter(!showFilter)} />
                      <div
                        style={{ zIndex: '10', visibility: showFilter ? 'visible' : 'hidden' }}
                        className="filterDropdown"
                      >
                        {ownerList.map((el) => (
                          <label key={el} style={{ fontWeight: '400', fontSize: '0.7vw' }}>
                            {el}
                            <input
                              value={el}
                              onClick={(e) => {
                                handleFilter(e);
                              }}
                              style={{ float: 'right' }}
                              type="checkbox"
                            />
                          </label>
                        ))}
                      </div>
                    </th>

                    <th>
                      Date Created{' '}
                      <TiArrowUnsorted
                        className="sortIcon"
                        onClick={() => {
                          const newArr = displayList.sort((a: any, b: any) =>
                            dateOrder ? a.CreatedAt.localeCompare(b.CreatedAt) : b.CreatedAt.localeCompare(a.CreatedAt),
                          );
                          setDisplayList(newArr);
                          setDateOrder(!dateOrder);
                        }}
                        style={{ fontSize: '.7vw' }}
                      />
                    </th>

                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {displayList.map((element: any, index: any) => (
                    <tr
                      key={index}
                      style={{ cursor: 'pointer', color: selectedTemplate?.Id === element.Id ? '#20C933' : '' }}
                    >
                      <td
                        onClick={() => {
                          setSelectedTemplate(element);
                        }}
                      >
                        {element.Name}
                      </td>
                      <td
                        onClick={() => {
                          setSelectedTemplate(element);
                        }}
                      >
                        {element.CreatedBy}
                      </td>
                      <td
                        onClick={() => {
                          setSelectedTemplate(element);
                        }}
                      >
                        {element.CreatedAt.split('T')[0]}
                      </td>
                      <td style={{ textAlign: 'center' }} onClick={() => templateDelete(element.Id)}>
                        <AiOutlineDelete className="deleteIcon" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {saveTemplateMessage && (
              <div>
                <p>{saveTemplateMessage}</p>
              </div>
            )}
            <DarkButton
              onClick={handleOK}
              disabled={isDeleting}
              style={{ alignSelf: 'flex-end' }}
              className="scaleHover"
              type="button"
            >
              {isDeleting ? 'Processing...' : 'OK'}
            </DarkButton>
          </ModulContainer>
        </HeadModul>
      </Modal>
    </>
  );
}

export default PickTemplate;
